// extracted by mini-css-extract-plugin
export default {"cls1":"Header-cls1_b5u","cls2":"Header-cls2_Flw Header-cls1_b5u"};